export const measurableProduct = {
    isMeasurable: 'T',
    isNotMeasurable: 'F'
};


export const WEIGHABLE_REASON = {
    WEIGHABLE: 'WEIGHABLE'
}
